/**
 * Created by gk-lab on 28.12.16.
 */
import React, { Component } from 'react';

class BodyScroll extends Component {
    static propTypes = {
        isScrollable: React.PropTypes.bool
    }
    static defaultProps = {
        isScrollable: true
    }
    componentDidMount() {
        document.body.classList.toggle('noscroll', !this.props.isScrollable)
    }
    componentWillReceiveProps(nextProps) {
        document.body.classList.toggle('noscroll', !nextProps.isScrollable)
    }
    componentWillUnmount() {
        document.body.classList.remove('noscroll')
    }
    render() {
        return this.props.children
    }
}

export default BodyScroll;


// WEBPACK FOOTER //
// ./src/components/BodyScroll/BodyScroll.js